export default function MobileVersionNotAvailable() {
  return (
    <div className="flex flex-col gap-3 text-center text-lg h-full w-full justify-center items-center">
      <p className="text-7xl">🙇‍♂🙇‍♀</p>
      <p>Our apologies!</p>
      <p>
        Talking Parties is <u>currently</u> only available for use on:
      </p>
      <p>
        Tablets <br /> Laptops <br /> Desktops
      </p>
    </div>
  );
}
